














import Vue from 'vue';
import ZenButton from '@reciprocity/button';

import { ProgramStage } from '../programHelpers';

enum ObjectType {
  Standard = 'standards',
  Section = 'sections',
  Objective = 'objectives',
  Control = 'controls',
}

export default Vue.extend({
  name: 'ScopedChildPresenter',
  components: {
    ZenButton,
  },
  props: {
    program: {
      type: Object,
      required: true,
    },
    objectType: {
      type: String as () => ObjectType,
      required: true,
    },
    filterFinalized: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    relevantStage(): ProgramStage {
      return {
        standards: ProgramStage.ScopingStandards,
        sections: ProgramStage.ScopingSections,
        objectives: ProgramStage.ScopingObjectives,
        controls: ProgramStage.Mapping,
      }[this.objectType as ObjectType];
    },
    text() {
      let action, status, count;

      if (this.objectType === ObjectType.Control) {
        action = 'Map';
        status = 'mapped';
        if (this.filterFinalized) {
          const controls = this.program.mappings.controls.edges;
          const final = controls.filter(c => c.node.status.value === 'Final');
          count = this.program.stage === this.relevantStage ? false : final.length;
        } else {
          count = this.program.mappings.controls.edgeCount;
        }
      } else {
        action = 'Scope';
        status = 'in scope';
        count = this.program.scopedCounts[this.objectType];
      }

      return this.program.stage === this.relevantStage ? `${action} ${this.objectType}` : `${count} ${status}`;
    },
    variant() {
      if (this.program.stage === this.relevantStage) {
        return 'outline-secondary';
      } else {
        return 'link';
      }
    },
    disabled() {
      return this.program.stage < this.relevantStage;
    },
    link() {
      return {
        name: 'programScopingPSSOScoping',
        params: {
          programId: this.program.id,
          objectType: this.objectType,
        },
      };
    },
  },
});
